import { Permission, type SkillManifest } from '@brandschutz/shared';
import type { FrontendSkill } from '../_core/registry';
import { MarkupGallery } from './MarkupGallery';

/**
 * Manifest in eigener Datei, damit das Bootstrap-Modul den schweren Editor-Code
 * (Konva + pdfjs ~450 KB) NICHT lädt — nur den schlanken Manifest-Eintrag
 * plus die leichte Galerie-Komponente.
 *
 * Der eigentliche Editor (`MarkupPage`) wird über React.lazy() in App.tsx
 * geladen und landet in einem eigenen Chunk.
 *
 * `MarkupGallery` ist bewusst leicht (nur fetch + img + Link) und ohne Konva-
 * Dependency — sie kann direkt in den Slot `project-detail.tabs` eingebunden
 * werden, ohne die Bundle-Größe aufzublähen.
 */
const manifest: SkillManifest = {
  key: 'floor-plan-editor',
  name: 'CAD-Markup-Editor',
  description:
    'Konva-basierter Markup-Editor mit PDF-Background, DIN-Symbolen, Maßketten und Kalibrierung. ' +
    'Im Projekt-Detail erscheint eine Galerie-Sektion mit allen Markup-Szenen als Thumbnails.',
  category: 'plugin',
  version: '0.1.0',
  requiredPermissions: [Permission.PROJECT_READ, Permission.PROJECT_UPDATE],
  enabledByDefault: true,
};

export const floorPlanEditorSkill: FrontendSkill = {
  manifest,
  slots: {
    'project-detail.tabs': [
      {
        key: 'markup-gallery',
        order: 60,
        // @ts-expect-error Slot context shape ist dynamic — Caller liefert projectId
        render: MarkupGallery,
      },
    ],
  },
};
